import styled from 'styled-components';
import { grey80 } from 'Styles/colors';

export const PaginationDots = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid ${grey80};
  margin-right: 8px;
  background-color: ${(props) => props.selected && grey80};

  &:last-child {
    margin-right: 0;
  }
`;
